export const normalizeUrl = (url: string): string =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;
